import { useEffect, useRef } from "react";

/**
 * Animacao tecnica de fundo para o hero da Valuare JR.
 * Planta 2D desenhada a laser, duas medicoes com correcao imediata
 * de uma cota divergente, e conversao para volume. Ciclo de 16s.
 *
 * Nao recebe props. Deve ser colocada num contentor com position:relative;
 * ela propria preenche 100% do espaco disponivel.
 */
export default function ValuarePlanta() {
  const svgRef = useRef(null);

  useEffect(() => {
    let rafId = null;
    let intervalId = null;
    let stopped = false;
    let ticks = 0;
    const filterId = "vjrGlow-" + Math.random().toString(36).slice(2, 8);

    var NS='http://www.w3.org/2000/svg';
    const svg=svgRef.current; if(!svg) return;
    var gFloor=svg.querySelector('#vpFloor'),gExt=svg.querySelector('#vpExt'),
        gWall=svg.querySelector('#vpWall'),gOpen=svg.querySelector('#vpOpen'),
        gDims=svg.querySelector('#vpDims'),gBeam=svg.querySelector('#vpBeam');

    var S=0.85, H=60, CX=600, CY=300, LIFT=26, TH=9, t3=0;

    function P(x,y,z){z=z||0;var fx=x*S,fy=y*S,ix=(x-y)*0.75*S,iy=((x+y)*0.42-z)*S;
      return [CX+fx+(ix-fx)*t3, CY+fy+(iy-fy)*t3+t3*LIFT];}
    function pt(p,z){return P(p[0],p[1],z);}
    function d(a){return 'M'+a.map(function(p){return p[0].toFixed(1)+' '+p[1].toFixed(1)}).join(' L');}
    function mk(t,a,p){var e=document.createElementNS(NS,t);for(var k in a)e.setAttribute(k,a[k]);p.appendChild(e);return e;}
    function off(a,b,s){var dx=b[0]-a[0],dy=b[1]-a[1],L=Math.hypot(dx,dy)||1;
      return [[a[0]-dy/L*s,a[1]+dx/L*s],[b[0]-dy/L*s,b[1]+dx/L*s]];}
    function arcPts(cx,cy,r,a0,a1,n){var o=[];for(var i=0;i<=n;i++){var a=(a0+(a1-a0)*i/n)*Math.PI/180;
      o.push([cx+r*Math.cos(a),cy+r*Math.sin(a)]);}return o;}

    // Envolvente construida x -500..60, terraco x 60..500
    var WALLS=[
     [[-500,-200],[-380,-200]],[[-280,-200],[-60,-200]],[[40,-200],[60,-200]],
     [[60,-200],[60,-120]],[[60,60],[60,200]],
     [[60,200],[-140,200]],[[-220,200],[-500,200]],
     [[-500,200],[-500,60]],[[-500,-60],[-500,-200]],
     [[-300,-200],[-300,-120]],[[-300,-60],[-300,100]],[[-300,160],[-300,200]],
     [[-500,-50],[-300,-50]],[[-500,75],[-300,75]],
     [[-150,-200],[-150,-60]],[[-300,-60],[-230,-60]],[[-170,-60],[-150,-60]],
     [[-150,90],[-150,130]],[[-150,180],[-150,200]],[[-300,90],[-150,90]]
    ];
    var WINDOWS=[[[-380,-200],[-280,-200]],[[-60,-200],[40,-200]],
                 [[-500,60],[-500,-60]],[[60,-120],[60,60]]];
    var DOORS=[
     {c:[-300,-120],r:60,a0:180,a1:90,l:[[-300,-120],[-360,-120]]},
     {c:[-300,100],r:60,a0:180,a1:90,l:[[-300,100],[-360,100]]},
     {c:[-140,200],r:80,a0:270,a1:180,l:[[-140,200],[-140,120]]},
     {c:[-150,130],r:50,a0:0,a1:90,l:[[-150,130],[-100,130]]},
     {c:[-170,-60],r:60,a0:90,a1:180,l:[[-170,-60],[-170,0]]}
    ];
    var TERR=[[60,-200],[500,-200],[500,200],[60,200]];
    // Duas medicoes apenas: uma confirma o declarado, a outra corrige
    var DIMS=[
     {a:[-500,-200],b:[-60,-200],o:[0,-46],val:8.35,dec:8.35,bad:0},
     {a:[-500,200],b:[60,200],o:[0,48],val:10.60,dec:9.15,bad:1}
    ];
    var AREAS=[];

    // Brilho suave para o feixe e para os nos
    var defs=mk('defs',{},svg);
    var fg=mk('filter',{id:filterId,x:'-60%',y:'-60%',width:'220%',height:'220%'},defs);
    mk('feGaussianBlur',{stdDeviation:'4',result:'b'},fg);
    var fm=mk('feMerge',{},fg); mk('feMergeNode',{in:'b'},fm); mk('feMergeNode',{in:'SourceGraphic'},fm);
    try{ gBeam.setAttribute('filter','url(#'+filterId+')'); }catch(e){}

    var floorEl=mk('path',{fill:'#EEF3F8',stroke:'none'},gFloor);
    var sheenEl=mk('path',{fill:'none',stroke:'#4A7BA8','stroke-width':'2',opacity:'0'},gFloor);
    var terrEl=mk('path',{fill:'#E4F0EA','fill-opacity':'.55',stroke:'#6FA898',
      'stroke-width':'1','stroke-dasharray':'6 5',opacity:'0'},gFloor);
    var gridDefs=[];
    for(var g=-440;g<=0;g+=70) gridDefs.push({v:1,a:g});
    for(var g2=-140;g2<=140;g2+=70) gridDefs.push({v:0,a:g2});
    var gridEls=gridDefs.map(function(){return mk('path',{stroke:'#B9CBDC','stroke-width':'1'},gFloor)});

    var extEls=WALLS.map(function(){return mk('path',{fill:'#DCE6F0','fill-opacity':'.75',
      stroke:'#7A9DBF','stroke-width':'.9',opacity:'0'},gExt)});
    var wA=WALLS.map(function(){return mk('path',{fill:'none',stroke:'#2D4A66','stroke-width':'1.3'},gWall)});
    var wB=WALLS.map(function(){return mk('path',{fill:'none',stroke:'#2D4A66','stroke-width':'1.3'},gWall)});
    var winEls=WINDOWS.map(function(){return mk('path',{fill:'none',stroke:'#4A7BA8','stroke-width':'1',opacity:'0'},gOpen)});
    var doorEls=DOORS.map(function(){return {
      arc:mk('path',{fill:'none',stroke:'#7A9DBF','stroke-width':'.9','stroke-dasharray':'3 4',opacity:'0'},gOpen),
      leaf:mk('path',{fill:'none',stroke:'#2D4A66','stroke-width':'1.2',opacity:'0'},gOpen)};});
    var dimEls=DIMS.map(function(){return{
      line:mk('path',{fill:'none',stroke:'#7A9DBF','stroke-width':'.9',opacity:'0'},gDims),
      txt:mk('text',{'text-anchor':'middle','font-size':'11',fill:'#4A7BA8',opacity:'0'},gDims),
      bar:mk('path',{stroke:'#C63B31','stroke-width':'1.3',opacity:'0'},gDims)};});
    var areaEls=AREAS.map(function(){return mk('text',{'text-anchor':'middle','font-size':'12',
      fill:'#4A7BA8',opacity:'0','letter-spacing':'.1em'},gDims)});

    var CORNERS=[[-500,-200],[60,-200],[60,200],[-500,200],[-300,-50],[-300,75],[-150,90]];
    var nodeEls=CORNERS.map(function(){return mk('circle',{r:'2.6',fill:'#4A7BA8',opacity:'0'},gDims)});
    var ringEls=[0,1].map(function(){return mk('ellipse',{fill:'none',stroke:'#7A9DBF','stroke-width':'1',opacity:'0'},gFloor)});
    var MOTE=[];
    for(var mi=0;mi<16;mi++) MOTE.push({x:-500+Math.random()*1000,y:-200+Math.random()*400,
      ph:Math.random()*6.28,sp:0.5+Math.random()*0.8,r:0.9+Math.random()*0.9});
    var moteEls=MOTE.map(function(){return mk('circle',{fill:'#4A7BA8',opacity:'0'},gDims)});

    var bGlow=mk('line',{stroke:'#C63B31','stroke-width':'10',opacity:'0'},gBeam);
    var bLine=mk('line',{stroke:'#C63B31','stroke-width':'1.5',opacity:'0'},gBeam);
    var bTip=mk('circle',{r:'4',fill:'#C63B31',opacity:'0'},gBeam);
    var bRing=mk('circle',{r:'10',fill:'none',stroke:'#C63B31','stroke-width':'1',opacity:'0'},gBeam);
    var bTxt=mk('text',{'font-size':'12',fill:'#C63B31','text-anchor':'middle',opacity:'0'},gBeam);

    function sg(t,a,b){return t<=a?0:t>=b?1:(t-a)/(b-a)}
    function ez(u){return u<.5?4*u*u*u:1-Math.pow(-2*u+2,3)/2}
    function fmt(v){return v.toFixed(2).replace('.',',')}
    function nowms(){return (window.performance&&window.performance.now)?window.performance.now():Date.now();}

    // Linha temporal, ciclo de 18s
    var T0=2.0, STEP=1.55, MEAS=1.0;    // medicoes
    var X0=6.2, X1=8.2;                 // extrusao para 3D
    var AR=8.5;                         // areas
    var B0=11.6, B1=13.8;               // regresso a 2D
    var LOOP=16000, t0=nowms();
    // Velocidade unica em todos os dispositivos (PC e telemovel).
    var rate = 1;

    function frame(forceT){
      var T = (typeof forceT === 'number') ? forceT : (((nowms()-t0)*rate)%LOOP)/1000;
      t3=ez(sg(T,X0,X1))*(1-ez(sg(T,B0,B1)));
      var draw=ez(sg(T,0,1.9));

      floorEl.setAttribute('d',d([pt([-500,-200]),pt([60,-200]),pt([60,200]),pt([-500,200])])+' Z');
      floorEl.setAttribute('opacity',(0.85*draw).toFixed(2));
      terrEl.setAttribute('d',d(TERR.map(function(p){return pt(p)}))+' Z');
      terrEl.setAttribute('opacity',(ez(sg(T,1.1,2.1))*0.9).toFixed(2));
      gridDefs.forEach(function(gd,i){
        var q=gd.v?[pt([gd.a,-200]),pt([gd.a,200])]:[pt([-500,gd.a]),pt([60,gd.a])];
        gridEls[i].setAttribute('d',d(q));
        gridEls[i].setAttribute('opacity',(0.30*draw).toFixed(2));
      });

      WALLS.forEach(function(w,i){
        var p=ez(sg(T,0.1+i*0.055,1.1+i*0.055));
        var oa=off(w[0],w[1],TH/2),ob=off(w[0],w[1],-TH/2);
        wA[i].setAttribute('d',d([pt(oa[0]),pt(oa[1])]));
        wB[i].setAttribute('d',d([pt(ob[0]),pt(ob[1])]));
        [wA[i],wB[i]].forEach(function(e){
          e.setAttribute('stroke-dasharray','900');
          e.setAttribute('stroke-dashoffset',(900*(1-p)).toFixed(0));
          e.setAttribute('opacity',(1-t3*0.6).toFixed(2));});
        extEls[i].setAttribute('d',d([pt(w[0],0),pt(w[1],0),pt(w[1],H),pt(w[0],H)])+' Z');
        extEls[i].setAttribute('opacity',(t3*0.95).toFixed(2));
      });

      WINDOWS.forEach(function(w,i){
        var s='';[-TH/2,0,TH/2].forEach(function(k){var o=off(w[0],w[1],k);s+=d([pt(o[0]),pt(o[1])])+' ';});
        winEls[i].setAttribute('d',s);
        winEls[i].setAttribute('opacity',(ez(sg(T,1.4,2.0))*(1-t3*0.6)*0.8).toFixed(2));
      });

      DOORS.forEach(function(dr,i){
        doorEls[i].arc.setAttribute('d',d(arcPts(dr.c[0],dr.c[1],dr.r,dr.a0,dr.a1,14).map(function(p){return pt(p)})));
        doorEls[i].leaf.setAttribute('d',d([pt(dr.l[0]),pt(dr.l[1])]));
        var o=ez(sg(T,1.5+i*0.1,2.1+i*0.1))*(1-t3);
        doorEls[i].arc.setAttribute('opacity',(o*0.5).toFixed(2));
        doorEls[i].leaf.setAttribute('opacity',(o*0.85).toFixed(2));
      });

      var out=1-ez(sg(T,B0+1.0,B1+0.4));

      DIMS.forEach(function(dm,i){
        var e=dimEls[i];
        var ts=T0+i*STEP;              // inicio da medicao
        var te=ts+MEAS;                // fim da medicao, valor declarado aparece
        var fs=te+0.35, fe=fs+0.75;    // correcao imediata, logo a seguir
        var a=pt([dm.a[0]+dm.o[0],dm.a[1]+dm.o[1]]),b=pt([dm.b[0]+dm.o[0],dm.b[1]+dm.o[1]]);
        var na=pt(dm.a),nb=pt(dm.b);
        e.line.setAttribute('d',d([a,b])+
          ' M'+na[0].toFixed(1)+' '+na[1].toFixed(1)+' L'+a[0].toFixed(1)+' '+a[1].toFixed(1)+
          ' M'+nb[0].toFixed(1)+' '+nb[1].toFixed(1)+' L'+b[0].toFixed(1)+' '+b[1].toFixed(1));
        var mx=(a[0]+b[0])/2,my=(a[1]+b[1])/2,ty=my+(dm.o[1]>0?15:-7);
        e.txt.setAttribute('x',mx.toFixed(1));e.txt.setAttribute('y',ty.toFixed(1));

        var vis=ez(sg(T,te-0.25,te+0.35));
        var val=dm.dec,col='#2D4A66',bar=0;
        if(dm.bad){
          var fx=ez(sg(T,fs,fe));
          bar=(T>te&&T<fe)?sg(T,te,te+0.3)*(1-sg(T,fe-0.3,fe)):0;
          if(fx>0) val=dm.dec+(dm.val-dm.dec)*fx;
          col=(fx>=1)?'#2D4A66':'#C63B31';
        }
        e.line.setAttribute('opacity',(0.5*vis*out).toFixed(2));
        e.txt.setAttribute('opacity',(vis*out).toFixed(2));
        e.txt.setAttribute('fill',col);
        e.txt.textContent=fmt(val)+' m';
        e.bar.setAttribute('d',d([[mx-24,ty-4],[mx+24,ty-4]]));
        e.bar.setAttribute('opacity',(bar*out).toFixed(2));
      });

      AREAS.forEach(function(ar,i){
        var p=pt(ar.p);
        areaEls[i].setAttribute('x',p[0].toFixed(1));areaEls[i].setAttribute('y',p[1].toFixed(1));
        areaEls[i].textContent=ar.t;
        areaEls[i].setAttribute('opacity',
          (ez(sg(T,AR+i*0.25,AR+0.9+i*0.25))*(1-ez(sg(T,B0-0.4,B0+0.8)))*0.8).toFixed(2));
      });

      // Nos de canto a acender de forma desfasada
      CORNERS.forEach(function(cp,i){
        var p=pt(cp);
        nodeEls[i].setAttribute('cx',p[0].toFixed(1)); nodeEls[i].setAttribute('cy',p[1].toFixed(1));
        var pulse=0.35+0.45*Math.sin(T*1.9+i*0.9);
        nodeEls[i].setAttribute('opacity',(draw*out*pulse*0.8).toFixed(2));
      });

      // Poeira lenta a subir sobre o plano
      MOTE.forEach(function(m,i){
        var yy=m.y-((T*m.sp*26+m.ph*40)%420);
        if(yy<-200) yy+=420;
        var p=pt([m.x,yy]);
        moteEls[i].setAttribute('cx',p[0].toFixed(1)); moteEls[i].setAttribute('cy',p[1].toFixed(1));
        moteEls[i].setAttribute('r',m.r.toFixed(1));
        moteEls[i].setAttribute('opacity',(draw*out*(0.14+0.18*Math.sin(T*1.3+m.ph))).toFixed(2));
      });

      // Onda de calibracao no arranque de cada ciclo
      ringEls.forEach(function(re,i){
        var rp=sg(T,1.6+i*0.55,4.4+i*0.55);
        var c=pt([-220,0]);
        re.setAttribute('cx',c[0].toFixed(1)); re.setAttribute('cy',c[1].toFixed(1));
        re.setAttribute('rx',(60+rp*470).toFixed(0));
        re.setAttribute('ry',((60+rp*470)*(0.42+0.2*t3)).toFixed(0));
        re.setAttribute('opacity',(rp>0&&rp<1?(1-rp)*0.30:0).toFixed(2));
      });

      // Varrimento de brilho ao longo do contorno, ao entrar em 3D
      var shp=sg(T,X0-0.3,X1+0.5);
      sheenEl.setAttribute('d',d([pt([-500,-200]),pt([60,-200]),pt([60,200]),pt([-500,200])])+' Z');
      sheenEl.setAttribute('stroke-dasharray','200 1800');
      sheenEl.setAttribute('stroke-dashoffset',(2000-shp*2000).toFixed(0));
      sheenEl.setAttribute('opacity',(shp>0&&shp<1?0.5:0).toFixed(2));

      var task=null;
      for(var i=0;i<DIMS.length;i++){
        var ts2=T0+i*STEP;
        if(T>=ts2&&T<ts2+MEAS) task={d:DIMS[i],p:sg(T,ts2,ts2+MEAS*0.92),live:1};
      }
      if(task){
        var zz=t3*H*0.45,s0=pt(task.d.a,zz);
        var cur=[task.d.a[0]+(task.d.b[0]-task.d.a[0])*task.p, task.d.a[1]+(task.d.b[1]-task.d.a[1])*task.p];
        var c=pt(cur,zz);
        [bGlow,bLine].forEach(function(l){
          l.setAttribute('x1',s0[0].toFixed(1));l.setAttribute('y1',s0[1].toFixed(1));
          l.setAttribute('x2',c[0].toFixed(1));l.setAttribute('y2',c[1].toFixed(1));});
        bGlow.setAttribute('opacity','.12');bLine.setAttribute('opacity','.9');
        bTip.setAttribute('cx',c[0].toFixed(1));bTip.setAttribute('cy',c[1].toFixed(1));bTip.setAttribute('opacity','1');
        bRing.setAttribute('cx',c[0].toFixed(1));bRing.setAttribute('cy',c[1].toFixed(1));
        bRing.setAttribute('r',(7+4*Math.sin(T*8)).toFixed(1));bRing.setAttribute('opacity','.42');
        bTxt.setAttribute('x',c[0].toFixed(1));bTxt.setAttribute('y',(c[1]-17).toFixed(1));
        bTxt.textContent=fmt(task.d.val*task.p);bTxt.setAttribute('opacity','.95');
      } else {
        [bGlow,bLine,bTip,bRing,bTxt].forEach(function(e){e.setAttribute('opacity','0')});
      }
      ticks++;
      if(!stopped) rafId = window.requestAnimationFrame(tick);
    }



    function tick() { frame(); }

    frame();
    try {
      rafId = window.requestAnimationFrame(tick);
    } catch (e) {}
    // Rede de seguranca: se rAF nao disparar (documento tido como nao
    // visivel, painel de pre-visualizacao), passa a setInterval.
    setTimeout(() => {
      if (!stopped && ticks < 3 && !intervalId) {
        intervalId = window.setInterval(tick, 33);
      }
    }, 400);

    return () => {
      stopped = true;
      if (rafId) window.cancelAnimationFrame(rafId);
      if (intervalId) window.clearInterval(intervalId);
      // limpar os nos criados, para o React nao herdar estado antigo
      ["#vpFloor","#vpExt","#vpWall","#vpOpen","#vpDims","#vpBeam"].forEach((sel) => {
        const g = svg && svg.querySelector(sel);
        while (g && g.firstChild) g.removeChild(g.firstChild);
      });
    };
  }, []);

  return (
    <svg
      ref={svgRef}
      viewBox="0 0 1200 620"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      className="vjr-planta"
      style={{ position: "absolute", inset: 0, width: "100%", height: "100%", display: "block" }}
    >
      <g id="vpFloor" />
      <g id="vpExt" />
      <g id="vpWall" />
      <g id="vpOpen" />
      <g id="vpDims" />
      <g id="vpBeam" />
    </svg>
  );
}
